































































































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Axios from "axios";
import {
	Button,
	ButtonGroup,
	Modal,
	Table,
	Tag,
	Spin,
	Input,
	Form,
	FormItem,
	Card,
	Switch,
	Icon,
	Sider,
	MenuItem,
	Menu,
	Submenu,
	Content,
	Layout,
	Collapse,
	Message,
	Upload,
	// @ts-ignore
	Panel
} from "view-design";

Component.registerHooks(["beforeRouteEnter", "beforeRouteLeave", "beforeRouteUpdate"]);

@Component({
	components: {
		Button,
		ButtonGroup,
		Table,
		Modal,
		Tag,
		Spin,
		"i-input": Input,
		Form,
		FormItem,
		Card,
		Icon,
		Sider,
		Menu,
		MenuItem,
		Submenu,
		Content,
		Layout,
		Collapse,
		Panel,
		Upload,
		"i-switch": Switch
	}
})
export default class Intents extends Vue {
	public loading = true;
	public entityConfig: any = {};
	public location: string = "";
	public active = "config-intents";
	public activeIntent: any = [];
	public activeEntity: any = [];
	public dirty: boolean = false;

	public created() {
		this.loadEntity();
	}

	public loadEntity() {
		// @ts-ignore
		Spin.show();
		Axios.get("/super/entity").then(res => {
			console.log(res.data);
			if (typeof res.data.config !== "undefined" && typeof res.data.config === "object") {
				// Do a sanity check
				const entityConfig = res.data.config;
				if (typeof entityConfig.intents === "undefined" || typeof entityConfig.intents !== "object") {
					entityConfig.intents = {};
				}
				if (typeof entityConfig.entities === "undefined" || typeof entityConfig.entities !== "object") {
					entityConfig.entities = {};
				}
				if (typeof entityConfig.intents === "undefined" ||  typeof entityConfig.parameters !== "object") {
					entityConfig.parameters = {};
				}
				for (const [_intent, intentData] of Object.entries(entityConfig.intents) as any) {
					if (typeof intentData.name !== "object") {
						intentData.name = { en: "-", fi: "-" };
					}
					if (typeof intentData.description !== "object") {
						intentData.description = { en: "", fi: "" };
					}
				}
				this.entityConfig = entityConfig;
				this.location = res.data.location;
			} else {
				// This is a new Entity
				this.entityConfig = {
					intents: {},
					entities: {},
					parameters: {},
				};
			}
			// @ts-ignore
			Spin.hide();
		}).catch(err => {
			// @ts-ignore
			Modal.error({
				title: "Error",
				content: `${err} : Try refreshing page, if error persists then contact support`
			});
		});
	}

	public async save() {
		// @ts-ignore
		Spin.show();
		Axios.patch("/super/entity", { config: this.entityConfig })
			.then(res => {
				console.log(res);
				// @ts-ignore
				Message.success({
					content: this.$t("Saved"),
					duration: 10,
					background: true
				});
				this.dirty = false;
			})
			.catch(e => {
				// @ts-ignore
				Modal.error({
					title: this.$t("Error"),
					content: this.$t("Error saving.") + " " + e
				});
			});
		// @ts-ignore
		Spin.hide();
	}

	public addIntent() {
		let input = "";
		// @ts-ignore
		Modal.confirm({
			render: (h: any) =>
				h(Input, {
					props: {
						value: "",
						autofocus: true,
						placeholder: this.$t("Intent Key")
					},
					on: {
						input: (val: string) => {
							input = val.toLowerCase();
						}
					}
				}),
			onOk: () => {
				if (input === "") {
					return alert(this.$t("Can't add an empty intent key"));
				}
				if (typeof this.entityConfig.intents[input] === "object") {
					return alert(this.$t("Intent already exists."));
				}
				console.log({ input });
				const newIntent: any = {};
				newIntent[input] = {
					hide: false,
					name: {
						en: "Unknown",
						fi: "Tuntematon"
					},
					description: {
						en: "Unknown",
						fi: "Tuntematon"
					}
				};
				this.entityConfig.intents = {
					...newIntent,
					...this.entityConfig.intents
				};
				this.activeIntent = [input];
				this.$forceUpdate();
			}
		});
	}

	public exportIntents() {
		const element = document.createElement("a");
		element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(this.entityConfig.intents, undefined, "\t")));
		element.setAttribute("download", `neuvola-${this.location}-intents-${new Date().toISOString().substr(0, 16).replace(":", "-")}.json`);
		element.style.display = "none";
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}

	public importIntents() {
		// @ts-ignore
		Modal.confirm({
			render: (h: any) => [
				h("strong", this.$t("WARNING! Existing intents will be replaces completely. NOT merged.")),
				h("input", {
					attrs: {
						type: "file",
						autofocus: true,
						placeholder: this.$t("Upload"),
						style: "margin-top: 15px",
						id: "neuvo-intents-upload"
					}
				})
			],
			onOk: () => {
				try {
					// @ts-ignore
					const file = document.getElementById("neuvo-intents-upload").files[0];
					const reader = new FileReader();
					reader.readAsText(file, "UTF-8");
					reader.onload = event => {
						try {
							this.entityConfig.intents = JSON.parse(event?.target?.result as string);
						} catch (e) {
							alert("Error parsing file. " + e);
						}
					};
					reader.onerror = event => {
						throw event;
					};
					this.dirty = true;
					this.$forceUpdate();
				} catch (e) {
					alert(this.$t("Error importing. ") + e);
				}
			}
		});
	}

	public exportEntities() {
		const element = document.createElement("a");
		element.setAttribute("href", "data:text/plain;charset=utf-8," + encodeURIComponent(JSON.stringify(this.entityConfig.entities, undefined, "\t")));
		element.setAttribute("download", `neuvola-${this.location}-entities-${new Date().toISOString().substr(0, 16).replace(":", "-")}.json`);
		element.style.display = "none";
		document.body.appendChild(element);
		element.click();
		document.body.removeChild(element);
	}

	public importEntities() {
		// @ts-ignore
		Modal.confirm({
			render: (h: any) => [
				h("strong", this.$t("WARNING! Existing entities will be replaces completely. NOT merged.")),
				h("input", {
					attrs: {
						type: "file",
						autofocus: true,
						placeholder: this.$t("Upload"),
						style: "margin-top: 15px",
						id: "neuvo-entities-upload"
					}
				})
			],
			onOk: () => {
				try {
					// @ts-ignore
					const file = document.getElementById("neuvo-entities-upload").files[0];
					const reader = new FileReader();
					reader.readAsText(file, "UTF-8");
					reader.onload = event => {
						try {
							this.entityConfig.entities = JSON.parse(event?.target?.result as string);
						} catch (e) {
							alert("Error parsing file. " + e);
						}
					};
					reader.onerror = event => {
						throw event;
					};
					this.dirty = true;
					this.$forceUpdate();
				} catch (e) {
					alert(this.$t("Error importing. ") + e);
				}
			}
		});
	}

	public addEntity() {
		let input = "";
		// @ts-ignore
		Modal.confirm({
			render: (h: any) =>
				h(Input, {
					props: {
						value: "",
						autofocus: true,
						placeholder: this.$t("Entity Key")
					},
					on: {
						input: (val: string) => {
							input = val.toLowerCase();
						}
					}
				}),
			onOk: () => {
				if (input === "") {
					return alert(this.$t("Can't add an empty entity key"));
				}
				if (typeof this.entityConfig.entities[input] === "object") {
					return alert(this.$t("Entity already exists."));
				}
				console.log({ input });
				const newEntity: any = {};
				newEntity[input] = {
					hide: false,
					name: {
						en: "Unknown",
						fi: "Tuntematon"
					},
					description: {
						en: "...",
						fi: "..."
					},
					values: {}
				};
				this.entityConfig.entities = {
					...newEntity,
					...this.entityConfig.entities
				};
				this.activeEntity = [input];
				this.$forceUpdate();
			}
		});
	}

	public addValue(entity: string | number) {
		let input = "";
		// @ts-ignore
		Modal.confirm({
			render: (h: any) =>
				h(Input, {
					props: {
						value: "",
						autofocus: true,
						placeholder: this.$t("Value Key for \"{entity}\"", { entity })
					},
					on: {
						input: (val: string) => {
							input = val.toLowerCase();
						}
					}
				}),
			onOk: () => {
				if (input === "") {
					return alert(this.$t("Can't add an empty entity key"));
				}
				if (typeof this.entityConfig.entities[input] === "object") {
					return alert(this.$t("Entity already exists."));
				}
				console.log({ input });
				const newValue: any = {};
				newValue[input] = {
					name: {
						en: "Unknown",
						fi: "Tuntematon"
					},
					hide: false
				};
				this.entityConfig.entities[entity].values = {
					...newValue,
					...this.entityConfig.entities[entity].values
				};
				this.$forceUpdate();
			}
		});
	}

	public beforeRouteLeave(to: any, from: any, next: any) {
		if (this.dirty) {
			// @ts-ignore
			const answer = window.confirm(this.$t("Do you really want to leave? You have unsaved changes!"));
			if (answer) {
				next();
			} else {
				next(false);
			}
		} else {
			next();
		}
	}

	@Watch("entityConfig", { deep: true })
	private watchForDirtyChanges() {
		if (!this.loading) {
			this.dirty = true;
		}
		this.loading = false;
	}
}
